<template>
	<div v-if="showOverlay" class="contact-overlay">
		<button class="btn btn-close-overlay p-0" @click="closeOverlay">
			<font-awesome-icon :icon="['custom', 'xmark']" />
		</button>
		<div class="container">
			<div class="row">
				<div class="get-in-touch" data-aos="fade-up">
					<h4>{{ GetInTouchText }}</h4>
					<div v-if="isSentSuccessfully" class="success-message mb-2">
						{{ succesMessage }}
					</div>
					<div v-if="errorMessage" class="error-message mb-2">
						{{ errorMessage }}
					</div>
					<div v-if="isLoading" class="loading-spinner mb-2">
						Sending...
					</div>
					<form class="contact-form mb-4">
						<div class="input-group w-70">
							<input
								v-model="email"
								type="email"
								class="form-control mb-2"
  						:placeholder="$t('forms.placeholders.emailRequired')"
								:class="{ 'input-error': inputError }"
								required
							/>
						</div>
						<div class="input-group">
							<textarea
								v-model="message"
								type="text"
								class="form-control"
								:placeholder="$t('messagePlaceholder')"
								:class="{ 'input-error': inputError }"
								required
							/>
							<div class="input-group-append">
								<button
									type="submit"
									class="btn btn-submit"
									@click.prevent="send"
								>
									<SpinnerIcon v-if="isLoading" />
									<font-awesome-icon v-else :icon="['custom', 'paper']" />
								</button>
								<a href="tel:6031112298" class="btn-phone">
									<font-awesome-icon :icon="['custom', 'phone']" />
								</a>
							</div>
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import SpinnerIcon from './SpinnerIcon'
import { useTeamStore } from '~/composables/useTeamStore'
export default {
	components: {
		SpinnerIcon
	},
	data() {
		return {
			GetInTouchText: 'Get in Touch!',
			email: '',
			message: '',
			errorMessage: '',
			isLoading: false,
			isSentSuccessfully: false,
			inputError: false,
			translatedTexts: {
				succesMessage: '',
				emptyFields: '',
				invalidEmail: ''
			}
		}
	},
	computed: {
		showOverlay() {
			return useTeamStore().showOverlay.value
		}
	},
	watch: {
		showOverlay(newValue) {
			if (newValue) {
				document.body.style.overflow = 'hidden'
			} else {
				document.body.style.overflow = ''
			}
		},
		email(value) {
			if (value) {
				this.inputError = false
			}
		},
		message(value) {
			if (value) {
				this.inputError = false
			}
		},
		'$i18n.locale': 'translateTexts'
	},
	mounted() {
		this.translateTexts()
	},
	methods: {
		closeOverlay() {
			useTeamStore().showOverlay.value = false
		},
		isValidEmail(email) {
			const re = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/
			return re.test(email)
		},
		async send() {
			this.inputError = false
			if (!this.email || !this.message) {
				this.errorMessage = this.translatedTexts.emptyFields
				this.inputError = true
				return
			}
			if (!this.isValidEmail(this.email)) {
				this.errorMessage = this.translatedTexts.invalidEmail
				this.inputError = true
				return
			}
			this.isLoading = true
			this.errorMessage = ''

			try {
				const response = await $fetch('/email/send', {
					method: 'POST',
					body: {
						from: 'booking@cromatics.de',
						subject: 'Contact form Get in Touch!',
						text: this.message
					}
				})

				this.isLoading = false
				this.isSentSuccessfully = true

				this.successTimeout = setTimeout(() => {
					this.isSentSuccessfully = false
				}, 5000)

				console.log('E-Mail gesendet:', response)
			} catch (error) {
				this.isLoading = false

				console.error('Fehler beim Senden der E-Mail:', error)
			}
		},
		translateTexts() {
			this.translatedTexts.succesMessage = this.$t('succesMessage')
			this.translatedTexts.emptyFields = this.$t('emptyFields')
			this.translatedTexts.invalidEmail = this.$t('errorMessage')
		}
	}
}
</script>

<style lang="scss">
.contact-overlay {
	position: fixed;
	z-index: 99999;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.828);
	backdrop-filter: blur(5px);
	.btn-close-overlay {
		position: absolute !important;
		top: 0;
		right: 0;
		margin: 20px;
	}
	.get-in-touch {
		margin-top: 35vh;
		padding: 5px;
		color: $white;
		.input-group {
			width: 95%;
			align-items: center;
			svg {
				color: $white;
				font-size: 20px;
			}
			.btn {
				padding: 20px;
			}
			.form-control {
				border-radius: 0;
				border-color: $white;
				color: $white;
				&::placeholder {
					color: $white;
				}
			}
			&.w-70 {
				width: 70%;
			}
		}
		.input-group-append {
			display: flex;
			align-items: center;
			gap: 15px;
			svg {
				color: $white !important;
			}
		}
	}
	.input-error {
		border-color: $orange !important;
	}
}
</style>
